<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ovGmVK/media/FC-9781528991650.jpg?1708206041616" alt="This image is the cover for the book The PepperAsh Clinch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The PepperAsh Clinch
      </h1>
      <p class="bookDescription body article font2">
        <p>A line of revellers, wending their drunken conga from the opening night party at The Fighting Cock, is brought to a sudden halt when their barbecue explodes. Nora Stickleback struggles to manage the pub, control her alcoholic husband, and keep her son away from temptation. Following a promise to look after her friends’ teenage children while they go off on a holiday that ends in tragedy, she suddenly finds herself with two extra youngsters to look after. Henry Stickleback nurses two passions, one for young Rosalie and the other for browsing car boot sales for any item cockerel-related. George dedicates the time he should be grieving to looking after his elder sister and carving out a future career for himself, steadfastly thinking of nothing except the matter in front of him at that time. Meanwhile, Rev’d Quinny is haunted by a childhood memory and a habit he started in order to break an obsession.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Franky Sayer
      </h2>
      
      <p class="authorDescription body article">Born in Felixstowe, Franky moved to North Suffolk as a small child. She still lives close to the Norfolk/Suffolk border with her husband, John, and their dog. Franky trained as a shorthand/typist/secretary and worked as such in a variety of industries, including a rock and sweet making factory, an offshore oil and gas platform construction company and as a local government officer. Other employment include music engraving and over two decades as a parish council clerk. Her hobbies include music – she plays tenor recorder, guitar, piano and church organ, and the last of these led to her becoming the chapel organist for twenty years in a local prison. Her other interests are artistic roller skating – she is a member of the Waveney Roller Skating Club; dressmaking, walking her dog in the countryside and reading. This is Franky’s first novel and also the first in The PepperAsh series. If you would like to know more about Franky and to follow her on Facebook, please go to ‘Franky Sayer Author’.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bbe391f6